import type { CartonAlias } from '@skupreme/api-contracts/core';
import { cartonSize, cartonWeight, unitsPerCarton } from '../lib/format';

/** One carton's size, units and weights, as label and value pairs. */
export function CartonSummary({
  alias = {},
  imperial,
}: {
  alias?: Partial<CartonAlias>;
  imperial: boolean;
}) {
  const facts = [
    ['Carton size', cartonSize(alias, imperial)],
    ['Quantity per carton', unitsPerCarton(alias)],
    ['Gross weight', cartonWeight(alias.carton_gross_weight, imperial)],
    ['Net weight', cartonWeight(alias.carton_net_weight, imperial)],
  ];

  return (
    <dl className="sk:m-0 sk:grid sk:grid-cols-[auto_1fr] sk:gap-x-4 sk:gap-y-0.5 sk:text-xs">
      {facts.map(([label, value]) => (
        <div key={label} className="sk:contents">
          <dt className="sk:text-fg-tertiary">{label}</dt>
          <dd className="sk:m-0 sk:text-right sk:tabular-nums sk:text-fg">
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
